const MASKS = ['google.', 'bing.com', 'yandex.', 'duckduckgo.', 'baidu.', 'yahoo.', 'ask.com']

export const isSearchEngine = (url?: string) => {
	if (!url) return false

	const {hostname} = new URL(url)
	return MASKS.some((mask) => hostname.includes(mask))
}
